<div class="footerComplex">
    <div class="beraterContainer">
        <div class="beraterDetails">
            <span class="beraterLabel">Ihr Ansprechpartner</span>
            <span class="beraterName" title="{{ contactPersonName }}">{{ contactPersonName }}</span>

            <a class="button btn-orange" href="mailto:{{ contactEmail }}">
                <i class="icon ico-mail">&#160;&#160;</i>{{ contactEmailFormatted }}
            </a>
            <a class="button btn-orange" href="tel:{{ contactNumber }}">
                <i class="icon ico-phone">&#160;&#160;</i>{{ contactNumberFormatted }}
            </a>
        </div>
    </div>
    <div class="linkContainer">
        <div class="footerItem">
            <a href="{{ urlFooterImpressum }}" target="_blank" rel="noopener noreferrer">Impressum</a>
        </div>
        <div class="footerItem">
            <a href="{{ urlFooterDatenschutz }}" target="_blank" rel="noopener noreferrer">Datenschutz</a>
        </div>
        <div class="footerItem">
            <a href="{{ urlFooterHilfe }}" target="_blank" rel="noopener noreferrer">Hilfe</a>
        </div>
    </div>
</div>
